import useLenis from "@/hooks/useLenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Manifesto from "@/components/Manifesto";
import QuoteContact from "@/components/QuoteContact";
import Footer from "@/components/Footer";

export default function Home() {
  useLenis();

  return (
    <div className="bg-white text-neutral-900 font-body" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Manifesto />
        <QuoteContact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid #e4e4e7",
            color: "#0a0a0a",
          },
        }}
      />
    </div>
  );
}
